<template>
    <createSurveyComponent />
</template>

<script>
import createSurveyComponent from "@/views/surveys/pages/create_survey/components/create_survey_component.vue"
export default {
    name: "createSurveyPage",
    components: {
        createSurveyComponent
    },
}
</script>

<style lang="css" scoped>
</style>
